export default __webpack_public_path__ + "static/media/yellowPlayVideoIcon.f4bed8d3.svg";